import { inject, Injectable } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';

import { filter, map, tap } from 'rxjs';

import { DownyMildewEvents, DownyMildewSyncStatusUpdatedEvent } from '../models/events';

@Injectable({
  providedIn: 'root',
})
export class DownyMildewNotificationService {
  private readonly notificationService = inject<NotificationService>(NotificationServiceInjector);

  // Set to track completed calculations and prevent racing conditions where 'Initiated' events
  // might arrive after 'Completed' or 'Failed' events for the same task.
  private readonly completedCalculations = new Set<string>();

  private readonly entry = this.notificationService
    .on<DownyMildewSyncStatusUpdatedEvent>(DownyMildewEvents.downyMildewSyncStatusUpdated)
    .pipe(map((event) => (typeof event === 'string' ? JSON.parse(event) : event) as DownyMildewSyncStatusUpdatedEvent));

  public readonly onInitiated = this.entry.pipe(
    filter((event) =>
      event.Status === 'Initiated' && !this.completedCalculations.has(event.CalculationTaskCode),
    ),
  );

  public readonly onCompleted = this.entry.pipe(
    filter((event) => event.Status === 'Completed'),
    tap((event) => this.completedCalculations.add(event.CalculationTaskCode)),
  );

  public readonly onFailed = this.entry.pipe(
    filter((event) => event.Status === 'Failed'),
    tap((event) => this.completedCalculations.add(event.CalculationTaskCode)),
  );
}
